import Reveal from "@/components/site/Reveal";
import SectionLabel from "@/components/site/SectionLabel";
import BookButton from "@/components/site/BookButton";
import { PHASES } from "@/lib/site";

export default function Phases() {
    return (
        <section
            data-testid="phases-section"
            className="relative bg-[#060c1e] py-24 md:py-32"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
                    <div className="md:col-span-7">
                        <Reveal>
                            <SectionLabel testId="phases-label">
                                The 90-Day Program
                            </SectionLabel>
                            <h2 className="mt-6 font-display font-black text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
                                Three phases.{" "}
                                <span className="text-[#D4AF37]">One</span>{" "}
                                transformation.
                            </h2>
                            <p className="mt-6 text-white/70 leading-relaxed text-base sm:text-lg max-w-2xl">
                                Each 30-day phase has a clear focus, weekly
                                objectives, and field work. You move through
                                them in sequence — because you can’t build
                                attraction on a broken mindset, and you can’t
                                sustain results without lifestyle.
                            </p>
                        </Reveal>
                    </div>
                </div>

                <div className="relative">
                    <div className="absolute left-[24px] md:left-1/2 md:-translate-x-1/2 top-2 bottom-2 w-px bg-[#142142]" />

                    <div className="space-y-12 md:space-y-20">
                        {PHASES.map((phase, i) => (
                            <Reveal key={phase.range} delay={i * 0.08}>
                                <div
                                    data-testid={`phase-${i + 1}`}
                                    className={`relative grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-20 items-start ${
                                        i % 2 === 1 ? "md:[direction:rtl]" : ""
                                    }`}
                                >
                                    <div
                                        className={`pl-16 md:pl-0 ${
                                            i % 2 === 1
                                                ? "md:[direction:ltr] md:text-right"
                                                : ""
                                        }`}
                                    >
                                        <span className="absolute left-0 top-0 md:left-1/2 md:-translate-x-1/2 w-12 h-12 border border-[#D4AF37] bg-[#020617] flex items-center justify-center font-display font-black text-[#D4AF37] text-sm">
                                            0{i + 1}
                                        </span>
                                        <p className="text-xs uppercase tracking-[0.28em] font-semibold text-[#D4AF37]">
                                            {phase.range}
                                        </p>
                                        <h3 className="mt-4 font-display font-black text-white text-3xl md:text-4xl leading-tight tracking-tight">
                                            {phase.title}
                                        </h3>
                                    </div>

                                    <div
                                        className={`pl-16 md:pl-0 ${
                                            i % 2 === 1
                                                ? "md:[direction:ltr]"
                                                : ""
                                        }`}
                                    >
                                        <ul className="space-y-3">
                                            {phase.bullets.map((b, bi) => (
                                                <li
                                                    key={bi}
                                                    className="flex items-start gap-3 text-white/80 leading-relaxed"
                                                >
                                                    <span className="w-1.5 h-1.5 bg-[#D4AF37] mt-2.5 flex-shrink-0" />
                                                    <span>{b}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>

                <div className="mt-20 text-center">
                    <BookButton
                        testId="phases-book-cta"
                        label="See If You Qualify"
                        size="lg"
                    />
                </div>
            </div>
        </section>
    );
}
